<template>
    <!-- 지원 접속 중인 탭에 늘(닫기 없음) — 계약 SUPPORT 5 배너 행 -->
    <div class="support-banner" role="status">
        <span class="support-banner-text">{{ text }}</span>
        <a-button size="small" danger :loading="ending" @click="end">접속 끝내기</a-button>
    </div>
</template>
<script>
import apiInstance from '@/axios';
import { getSupportSession } from '@/utils/tokenStore';
import { supportBannerText, supportProbe, SUPPORT_PROBE_MS, supportActivityReporter, SUPPORT_ACTIVITY_EVENTS } from '@/utils/supportSession';

export default {
    name: 'SupportBanner',
    data() {
        return { ending: false };
    },
    computed: {
        text() {
            return supportBannerText(getSupportSession());
        },
    },
    mounted() {
        // 배너 높이만큼 왼쪽 메뉴(position: fixed)를 내림 — 메뉴 맨 위(회사 이름·선택)를 가리지 않게(I23 D1, 병원과 같은 방식)
        document.body.classList.add('support-mode');
        // 가만히 있는 탭도 동의 철회·잠금 뒤 끝 화면으로(끝났으면 axios 응답 처리기가 endSupport)
        this.probeTimer = setInterval(() => supportProbe((url, config) => apiInstance.get(url, config)), SUPPORT_PROBE_MS);
        // 사람이 누르거나 입력할 때만 쉬는 시간(30분)을 되돌림
        this.reportActivity = supportActivityReporter((url, body, config) => apiInstance.post(url, body, config));
        SUPPORT_ACTIVITY_EVENTS.forEach((e) => window.addEventListener(e, this.reportActivity, { capture: true, passive: true }));
    },
    beforeUnmount() {
        document.body.classList.remove('support-mode');
        clearInterval(this.probeTimer);
        if (this.reportActivity) SUPPORT_ACTIVITY_EVENTS.forEach((e) => window.removeEventListener(e, this.reportActivity, { capture: true }));
    },
    methods: {
        async end() {
            this.ending = true;
            await this.$store.dispatch('endSupport');
        },
    },
};
</script>
<style>
/* 배너(36px) 아래에서 왼쪽 메뉴 시작. 메뉴는 top·bottom 으로 높이를 정함(height: 100% 면 아래가 잘림) */
body.support-mode #new-sidenav {
    top: 36px;
    height: auto;
}
</style>
<style scoped>
.support-banner {
    position: sticky;
    top: 0;
    z-index: 2000;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    box-sizing: border-box;
    height: 36px;
    padding: 0 16px;
    background: #d4380d;
    color: #fff;
    font-size: 13px;
    font-weight: 600;
}
.support-banner-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>
